import 'shared/trackjs'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import App from './components/app'

global.Giphy.renderSearch = (el, data) => {
    ReactDOM.render(
        <AppContainer>
            <App {...data} />
        </AppContainer>,
        el
    )
    if (module.hot) {
        module.hot.accept('./components/app', () => {
            const NextApp = require('./components/app').default
            ReactDOM.render(
                <AppContainer>
                    <NextApp {...data} />
                </AppContainer>,
                el
            )
        })
    }
}
